const $ = window.$;
export default function ($elem) {
	this.$outer = $elem;

	this.currentTabIndex = 0;

	this.setCurrentTabIndex = function($elem) {
		this.currentTabIndex = this.$outer.find(':tabbable').index($elem);
	};

	this.init = function() {
		var that = this;

		this.$outer.on('focus', ':tabbable', function() {
			that.setCurrentTabIndex($(this));
		});

		this.$outer.on('keydown', ':tabbable', function(e) {
			if (window.isTabKey(e)) {
				if (e.shiftKey) {
					// Focus last element if we attempt to move focus outside of container
					if (that.currentTabIndex - 1 < 0) {
						that.$outer.find(':tabbable').last().focus();
						e.preventDefault();
					}
				} else {
					// Focus first element if we attempt to move focus
					if (that.currentTabIndex + 1 > that.$outer.find(':tabbable').length - 1) {
						that.$outer.find(':tabbable').first().focus();
						e.preventDefault();
					}
				}
			}
		});
	};
}

$.fn.createFocusGuard = function() {
	var f = new window.FocusGuard($(this));

	f.init();
};